var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.148,
    height: 36.954,
    viewBox: "0 0 28.148 36.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11722",
    "data-name": "Path 11722",
    d: "M64.248,36.954H85.9a3.251,3.251,0,0,0,3.248-3.248V10.826H81.57a3.251,3.251,0,0,1-3.248-3.248V0H64.248A3.251,3.251,0,0,0,61,3.248V33.706A3.251,3.251,0,0,0,64.248,36.954Zm4.331-21.725H81.57a1.083,1.083,0,0,1,0,2.165H68.578a1.083,1.083,0,1,1,0-2.165Zm0,4.331H81.57a1.083,1.083,0,0,1,0,2.165H68.578a1.083,1.083,0,1,1,0-2.165Zm0,4.331H81.57a1.083,1.083,0,0,1,0,2.165H68.578a1.083,1.083,0,1,1,0-2.165Zm0,4.331h8.661a1.083,1.083,0,0,1,0,2.165H68.578a1.083,1.083,0,1,1,0-2.165Z",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11723",
    "data-name": "Path 11723",
    d: "M332.083,16.816h6.944L331,8.789v6.944A1.083,1.083,0,0,0,332.083,16.816Z",
    transform: "translate(-250.513 -8.155)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.ab1b02f035f25609955b1468cf423de5.svg";
export { ForwardRef as ReactComponent };